import { getSafeSupabaseClient } from '../supabaseSync';
import { unwrapRpcResult } from './rpcEnvelope';

export interface CreateRevisionRequestArgs {
  loopId: string;
  message: string;
  actorId: string;
  actorName?: string | null;
  reasonCode?: string | null;
}

export interface CreateRevisionRequestResult {
  success: boolean;
  revision_request_id: string;
  loop_id: string;
  loop_state: string;
}

/**
 * Create an explicit revision request.
 * 
 * Atomic transaction:
 * - Inserts revision_requests record with status OPEN
 * - Updates loop state to 'revision_requested' (if not already)
 * - Records loop transition
 * - Emits governance event (revision_request_created)
 */
export async function createRevisionRequest(args: CreateRevisionRequestArgs): Promise<CreateRevisionRequestResult> {
  const supabase = getSafeSupabaseClient();
  if (!supabase) {
    throw new Error('Supabase client not available');
  }

  if (!args.message || args.message.trim() === '') {
    throw new Error('Revision request message is required');
  }

  const { data, error } = await supabase.rpc('catchball_create_revision_request', {
    p_loop_id: args.loopId,
    p_message: args.message,
    p_actor_id: args.actorId,
    p_actor_name: args.actorName ?? null,
    p_reason_code: args.reasonCode ?? null,
  });

  // Refusals arrive either as a PostgREST error or as { success: false, error }.
  return unwrapRpcResult<CreateRevisionRequestResult>(data, error, 'The server refused the revision request.');
}
